"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomName = void 0;
const unique_names_generator_1 = require("unique-names-generator");
const randomName = (config) => (0, unique_names_generator_1.uniqueNamesGenerator)(config || {
    dictionaries: [unique_names_generator_1.adjectives, unique_names_generator_1.colors, unique_names_generator_1.animals],
    separator: "-",
    length: 1,
});
exports.randomName = randomName;
